import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getSchedulesLockStatus = api(async function getSchedulesLockStatus({ projectId, scheduleIds }) {
    return query(
        gql`
            query GetSchedulesLockStatus($projectId: String!, $scheduleIds: [String!]!) {
                getSchedulesLockStatus(projectId: $projectId, scheduleIds: $scheduleIds) {
                    isLocked
                    inCurrentProject
                    projectName
                    projectId
                    scheduleId
                }
            }
        `,
        { projectId, scheduleIds },
        { returns: "getSchedulesLockStatus" }
    )
})
